export default function Alert({
  style,
  variant,
  className,
  dismissable,
  onClose,
  children,
  ...props
}) {
  const computedClassName = [
    "alert",
    (!!variant && `alert-${variant}`) || "",
    ...className.split(" "),
    (!!dismissable && "alert-dismissable") || "",
  ]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} style={style} {...props}>
      {dismissable && (
        <button type="button" className="close" onClick={onClose}>
          <span aria-hidden="true">&times;</span>
        </button>
      )}
      {children}
    </div>
  );
}

Alert.defaultProps = {
  className: "",
};
